import { call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { gcApi } from '../config/axios';
import {
    ADD_COMMENT_LIKE,
    ADD_CONVERSASION_COMMENT,
    ADD_CONVERSATION_LIKE,
    ADD_GROUP_CONVERSATION_LIKE,
    FETCH_COMMENTS,
    FETCH_COMMENT_LIKES,
    FETCH_CONVERSATION,
    FETCH_CONVERSATION_LIKES,
    FETCH_CONVERSATION_LIKES_FETCHING,
    FETCH_CONVERSATION_LIKES_FINISHED,
    FETCH_GROUP_CONVERSATION,
    POST_CONVERSATION,
    POST_GROUP_CONVERSATION,
    REMOVE_COMMENT_LIKE,
    REMOVE_CONVERSATION_LIKE,
    REMOVE_GROUP_CONVERSATION_LIKE,
    DELETE_COMMENT,
    EDIT_COMMENT_START
} from '../actions/ActionTypes';
import { fetchConversationLikes } from 'actions/conversationLikesActions';
import { fetchGroupConversationLikes } from 'actions/groupConversationLikesActions';
import {
    fetchGroupConversation,
    failedComments,
    receiveComments,
    receiveConversation,
    requestComments,
    requestConversation,
    fetchComments,
    fetchConversation,
    postConversation,
    requestCommentLikes,
    receiveCommentLikes,
    commentAdded,
    manageComments,
    requestGroupConversation,
    receiveGroupConversation,
    postGroupConversation,
    manageCommentLikes,
    fetchCommentLikes,
    commentDeleted,
    commentEditDone,
    commentEditError,
    addCommentDone,
    setShowProfilePageGeneralError,
    setSocialLimitErrorDialog
} from '../actions';
import { fetchMultipleUserSocialProfileImage } from 'actions/userSocialProfileImageActions';

export function* fetchConversationLikesSaga(action) {
    const { resourceType, resourceId, start, limit, connectionStatusIncluded } = action.payload;

    try {
        yield put({
            type: FETCH_CONVERSATION_LIKES_FETCHING
        });

        let url = `conversation-service/conversation/likes/${resourceType}/${resourceId}`;
        if (
            typeof start != 'undefined' &&
            typeof limit != 'undefined' &&
            typeof connectionStatusIncluded != 'undefined'
        ) {
            url += `?start=${start}&limit=${limit}&connectionStatusIncluded=${connectionStatusIncluded}`;
        }

        const response = yield call(gcApi.get, url);

        yield put({
            type: FETCH_CONVERSATION_LIKES_FINISHED,
            data: response.data,
            receivedAt: Date.now(),
            resourceId
        });
    } catch (e) {
        console.log(e);
    }
}

export function* fetchCommentsSaga({ resourceType, resourceId, start = 1, limit = 10 }) {
    try {
        yield put(requestComments(resourceId));

        const response = yield gcApi.get(
            `/conversation-service/conversation/comments/${resourceType}/${resourceId}?start=${start}&limit=${limit}`
        );

        yield put(receiveComments(response.data, resourceId));

        yield fork(fetchCommentsProfileImageAndFrameSaga, response.data);
    } catch (e) {
        yield put(failedComments(resourceId));
    }
}

export function* fetchConversationSaga({ resourceType, resourceId }) {
    try {
        yield put(requestConversation());

        const response = yield gcApi.get(`/conversation-service/conversation/${resourceType}/${resourceId}`);

        if (response.data.conversationUuid) {
            yield put(receiveConversation(response.data, resourceId));
        } else {
            yield put(postConversation(resourceType, resourceId, response.data));
        }
    } catch (e) {}
}

export function* postConversationSaga({ resourceType, resourceId, data }) {
    try {
        const response = yield gcApi.post(`/conversation-service/conversation/${resourceType}/${resourceId}`, data);

        yield put(receiveConversation(response.data, resourceId));
    } catch (e) {}
}

export function* fetchCommentLikesSaga({ conversationCommentUuid }) {
    try {
        yield put(requestCommentLikes());

        const response = yield gcApi.get(`/conversation-service/conversation/comment/likes/${conversationCommentUuid}`);

        yield put(receiveCommentLikes(response.data, conversationCommentUuid));
    } catch (e) {}
}

export function* addCommentSaga({ resourceId, resourceType, data, shouldFetchComments }) {
    try {
        const response = yield gcApi.post(
            `/conversation-service/conversation/comment/${data.conversationUuid}/${data.conversationCommentUuid}`,
            data
        );

        if (!shouldFetchComments) {
            yield put(commentAdded(response.data, resourceId));
        }
        yield put(manageComments(resourceId, true));

        if (shouldFetchComments) {
            yield put(fetchComments(resourceType, resourceId));
        }
        yield put(fetchConversation(resourceType, resourceId));
        yield put(addCommentDone(resourceId, resourceType, data));
    } catch (e) {
        if (e.response && e.response.status === 429) {
            yield put(addCommentDone(resourceId, resourceType, data, 'limit'));
            yield put(setSocialLimitErrorDialog({ open: true, errorType: 'comment' }));
            yield put(setShowProfilePageGeneralError(false));
        } else {
            yield put(addCommentDone(resourceId, resourceType, data, true));
            yield put(setShowProfilePageGeneralError(true));
        }
    }
}

export function* deleteCommentSaga({ resourceType, resourceId, data }) {
    try {
        const response = yield gcApi.delete(
            `/conversation-service/conversation/comment/${data.conversationUuid}/${data.conversationCommentUuid}/${data.conversationCommentPk}`
        );

        yield put(commentDeleted(data, resourceId));
        yield put(manageComments(resourceId, false));
        yield put(fetchConversation(resourceType, resourceId));
    } catch (e) {}
}

export function* fetchGroupConversationSaga({ userGroupPk, resourceType, resourceId }) {
    try {
        yield put(requestGroupConversation());
        const response = yield gcApi.get(
            `/conversation-service/conversation/${userGroupPk}/${resourceType}/${resourceId}`
        );

        if (response.data.conversationUuid) {
            yield put(receiveGroupConversation(response.data, resourceId));
        } else {
            yield put(postGroupConversation(userGroupPk, resourceType, resourceId, response.data));
        }
    } catch (e) {}
}

export function* postGroupConversationSaga({ userGroupPk, resourceType, resourceId, data }) {
    try {
        const response = yield gcApi.post(
            `/conversation-service/conversation/${userGroupPk}/${resourceType}/${resourceId}`,
            data
        );

        yield put(receiveGroupConversation(response.data, resourceId));
    } catch (e) {}
}

export function* addCommentLikeSaga({ resourceType, resourceId, data }) {
    try {
        const response = yield gcApi.post(
            `/conversation-service/conversation/comment/like/${data.conversationCommentUuid}`,
            data
        );

        yield put(manageCommentLikes(resourceId, data.conversationCommentUuid, true));
        yield put(fetchCommentLikes(data.conversationCommentUuid));
    } catch (e) {
        if (e.response && e.response.status === 429) {
            yield put(setSocialLimitErrorDialog({ open: true, errorType: 'like' }));
        }
    }
}

export function* removeCommentLikeSaga({ resourceType, resourceId, conversationCommentUuid }) {
    try {
        const response = yield gcApi.delete(
            `/conversation-service/conversation/comment/like/${conversationCommentUuid}/0`
        );

        yield put(manageCommentLikes(resourceId, conversationCommentUuid, false));
        yield put(fetchCommentLikes(conversationCommentUuid));
    } catch (e) {}
}

export function* addConversationLikeSaga({ resourceType, resourceId, conversationUuid }) {
    try {
        const response = yield gcApi.post(`/conversation-service/conversation/like/${conversationUuid}`, {
            conversationUuid: resourceId
        });

        yield put(fetchConversation(resourceType, resourceId));
        yield put(fetchConversationLikes(resourceId, resourceType));
    } catch (e) {
        if (e.response && e.response.status === 429) {
            yield put(setSocialLimitErrorDialog({ open: true, errorType: 'like' }));
        }
    }
}

export function* removeConversationLikeSaga({ resourceType, resourceId, conversationUuid }) {
    try {
        const response = yield gcApi.delete(`/conversation-service/conversation/like/${conversationUuid}/0`);

        yield put(fetchConversation(resourceType, resourceId));
        yield put(fetchConversationLikes(resourceId, resourceType));
    } catch (e) {}
}

export function* addGroupConversationLikeSaga({ userGroupPk, resourceType, resourceId, conversationUuid }) {
    try {
        const response = yield gcApi.post(`/conversation-service/conversation/like/${conversationUuid}`, {
            conversationUuid: resourceId
        });

        yield put(fetchGroupConversation(userGroupPk, resourceType, resourceId));
        yield put(fetchGroupConversationLikes(userGroupPk, resourceId, resourceType));
    } catch (e) {
        if (e.response && e.response.status === 429) {
            yield put(setSocialLimitErrorDialog({ open: true, errorType: 'like', isGroup: true }));
        }
    }
}

export function* removeGroupConversationLikeSaga({ userGroupPk, resourceType, resourceId, conversationUuid }) {
    try {
        const response = yield gcApi.delete(`/conversation-service/conversation/like/${conversationUuid}/0`);

        yield put(fetchGroupConversation(userGroupPk, resourceType, resourceId));
        yield put(fetchGroupConversationLikes(userGroupPk, resourceId, resourceType));
    } catch (e) {}
}

export function* editCommentSaga({ comment, resourceId }) {
    try {
        const response = yield gcApi.put(
            `/conversation-service/conversation/comment/${comment.conversationUuid}/${comment.conversationCommentUuid}`,
            comment
        );
        yield put(commentEditDone(response.data, resourceId));
    } catch (error) {
        yield put(commentEditError(comment, resourceId, error));
    }
}

/// section: fetching profile image and frame

/**
 * handle comments profile images and frames
 * @param {Object[]} responseData
 * @param {number} responseData[].userProfilePk
 */
function* fetchCommentsProfileImageAndFrameSaga(responseData) {
    if (!responseData?.length) {
        return;
    }
    const userIds = responseData.map((item) => item.userProfilePk);
    yield fork(fetchProfileImageAndFrameSaga, userIds);
}

function* fetchProfileImageAndFrameSaga(userIds) {
    if (!userIds || !userIds.length) {
        return;
    }
    yield put(fetchMultipleUserSocialProfileImage(userIds));
}

/// end section: fetching profile image and frame

export const conversationLikesSagas = [
    takeEvery(FETCH_CONVERSATION_LIKES, fetchConversationLikesSaga),
    takeEvery(FETCH_COMMENTS, fetchCommentsSaga),
    takeEvery(FETCH_CONVERSATION, fetchConversationSaga),
    takeEvery(POST_CONVERSATION, postConversationSaga),
    takeEvery(FETCH_COMMENT_LIKES, fetchCommentLikesSaga),
    takeEvery(ADD_CONVERSASION_COMMENT, addCommentSaga),
    takeEvery(FETCH_GROUP_CONVERSATION, fetchGroupConversationSaga),
    takeEvery(POST_GROUP_CONVERSATION, postGroupConversationSaga),
    takeEvery(ADD_COMMENT_LIKE, addCommentLikeSaga),
    takeEvery(REMOVE_COMMENT_LIKE, removeCommentLikeSaga),
    takeEvery(ADD_CONVERSATION_LIKE, addConversationLikeSaga),
    takeEvery(REMOVE_CONVERSATION_LIKE, removeConversationLikeSaga),
    takeEvery(ADD_GROUP_CONVERSATION_LIKE, addGroupConversationLikeSaga),
    takeEvery(REMOVE_GROUP_CONVERSATION_LIKE, removeGroupConversationLikeSaga),
    takeLatest(DELETE_COMMENT, deleteCommentSaga),
    takeLatest(EDIT_COMMENT_START, editCommentSaga)
];
